export const getValueByKey = <T, K extends keyof T>(item: T, key: K): T[K] => item[key];
